"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRegionalPathname = void 0;
const with_trailing_slash_1 = require("../with-trailing-slash");
const parseRegionalPathname = ({ pathname, regionalLandingRoutes, regionNames, }) => {
    const regex = new RegExp(`^/?(${regionNames.join('|')})?(${regionalLandingRoutes.join('|')})$`);
    const result = (0, with_trailing_slash_1.withTrailingSlash)(pathname).match(regex);
    if (!result) {
        return null;
    }
    const [, capital, route] = result;
    return { capital, route };
};
exports.parseRegionalPathname = parseRegionalPathname;
//# sourceMappingURL=index.js.map